import ACTS from '../constants'

// import { GET_SCRAP_JASAN_INFOS, UNLOAD_SCRAP } from '../constants/actionTypes'

const defaultStatus = {
    title: '자동수집',
    tabId: 'scrap',
    jasanInfos: {},
    jasanInfosSub: {}
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.GET_SCRAP_JASAN_INFOS:            
            return {
                ...state,
                jasanInfos: action.payload.result === true ? action.payload.item : {},
                jasanInfosSub: action.payload.result === true ? action.payload.item : {}
            }

        case ACTS.UNLOAD_SCRAP:
            let temp = {...state};
            delete temp.jasanInfos;
            delete temp.jasanInfosSub;

            return temp;

        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/scrap.js